import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainMachine.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 

var httpURL = '';
var queryString = require('querystring');
var lstMachine =[];
var machineTypeIdCol 	= 'td:eq(0)';
var machineTypeCol 		= 'td:eq(1)';
var perDayCapacityCol 	= 'td:eq(2)';

class MaintainMachine extends Component {
  constructor(props){
	super(props);
	this.state={
		machine:[],
		flg:true,
		width:'97%',
		loader:'none',
		opacity:1,
	}
  }
  
  componentDidMount =()=> {
	  this.setState({loader:'block', opacity:0.5});  
	  axiosInstance.get(httpURL+'/a/mst/mty/list',{
		  withCredentials: true
	  }).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				this.setState({
					machine:response.data.lstMachineType,
				})
				lstMachine = this.state.machine;
				this.setMachineTable();
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
	  });
		this.handleResize();
		window.addEventListener("load", this.handleResize);
	  window.addEventListener("resize", this.handleResize);
  }
  
  handleResize=()=>{
	  var width = ($('.tableLayout1').parent().width())-18;
	  this.setState({width:width})
  }
  
  setMachineTable =()=> {
		$('#machineTableBody tr').remove();
		var table 				= document.getElementById('machineTable');
		var tbody 				= document.getElementById('machineTableBody');
		var filterMachineType 	= $('#machineType').val().toLowerCase();
		var filterPerDayCapacity= $('#perDayCapacity').val();
		
		for(var i=0; i<lstMachine.length; i++){
		var id 				= lstMachine[i].machineTypeId;
		var machineType		= lstMachine[i].machineType;
		var perDayCapacity	= lstMachine[i].capacity;
		
		var row = document.createElement('tr');
		row.id = id;
		row.onclick =(e)=>{
			$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			this.setMachineForm($(e.target).closest('tr').attr('id'));
			this.setState({flg:false})
		}
		
		if(machineType.toLowerCase().indexOf(filterMachineType) === -1)
			continue;
		if(perDayCapacity.toString().indexOf(filterPerDayCapacity) === -1)
			continue;
		
		this.addTD(row, id, 'no-display');
		this.addTD(row, machineType, '');
		this.addTD(row, perDayCapacity,'txtright');
		
		tbody.append(row);
		}
	table.append(tbody);
	}
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}
	
	setMachineForm =(id)=> {
		var machineData = this.getMachineData(id);
		if(machineData !== -1){
			$('#inp_machineType').val(machineData.machineType);
			$('#inp_perDayCapacity').val(machineData.capacity);
		}
	}
	
	getMachineData(id){
		for(var i = 0; i < lstMachine.length; i++){
			if(id == lstMachine[i].machineTypeId){
				return lstMachine[i];
			}
		}
		return -1;
	}
	
	addMachineReady =()=>{
		$('#machineAddForm').trigger('reset');
		this.setState({flg:true})
	}
	
	maintainMachine =()=>{
		if(this.state.flg){
			this.addMachine();
		}else{
			this.editMachine();
		}
	}
	
	addMachine(){
	var machine 		= {};
	var machineType		= $('#inp_machineType').val().toUpperCase();
	var perDayCapacity	= $('#inp_perDayCapacity').val();
	if(machineType == ''){
		toast.warning('Please fill Machine Type');
		document.getElementById('inp_machineType').focus();
		return false;
	}
	if(perDayCapacity == ''){
		toast.warning('Please fill per day capacity');
		document.getElementById('inp_perDayCapacity').focus();
		return false;
	}
	
	machine={'machineTypeId': 0, 'machineType':machineType, 'capacity':perDayCapacity}
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/a/mst/mty/save', 
		queryString.stringify({'machineType':JSON.stringify(machine)}), {withCredentials:true}
	).then((response)=>{	
		if(response.data.SvcStatus === "Success"){
			toast.success(response.data.SvcMsg);
			machine.machineTypeId = response.data.machineTypeId;
			lstMachine.push(machine);
			this.setMachineTable();
			this.setMachineForm(response.data.machineTypeId);
			this.highlightRow('machineTableBody', response.data.machineTypeId);
			this.setState({flg : false})
		}
		else{
			toast.error(response.data.SvcMsg);
		}
		this.setState({loader:'none', opacity:1});
 	}).catch((e)=>{
		toast.error("Service failed "+e);
  	});
  }

	editMachine(){
		var machine 		= {};
		var machineTypeId 	= $('#machineTableBody tr.selected').find(machineTypeIdCol).text();
		var machineType		= $('#inp_machineType').val().toUpperCase();
		var perDayCapacity	= $('#inp_perDayCapacity').val();
		
		if(machineTypeId == ''){
			toast.warning('Please select row');
			return false;
		}
		
		if(machineType == ''){
			toast.warning('Please fill Machine Type');
			document.getElementById('machineType').focus();
			return false;
		}
		if(perDayCapacity == ''){
			toast.warning('Please fill per day capacity');
			document.getElementById('perDayCapacity').focus();
			return false;
		}
		
		machine={'machineTypeId': machineTypeId, 'machineType':machineType, 'capacity':perDayCapacity}
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/a/mst/mty/save', 
			queryString.stringify({'machineType':JSON.stringify(machine)}), {withCredentials:true}
		).then((response)=>{	
			if(response.data.SvcStatus === "Success"){
				toast.success(response.data.SvcMsg);
				var machineIdx = this.getIdxMachine(machineTypeId);
				lstMachine.splice(machineIdx,1,machine);
				this.setMachineForm(machineTypeId);
				this.setMachineTable();
				this.highlightRow('machineTableBody', machineTypeId);
			}
			else{
				toast.error(response.data.SvcMsg);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((e)=>{
			toast.error("Service failed "+e);
		});
	}

	getIdxMachine(machineTypeId){
		for(var i=0; i<lstMachine.length; i++){
			if(lstMachine[i].machineTypeId == machineTypeId){
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var machineTypeId = $(this).find(machineTypeIdCol).text();
			if(machineTypeId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	
  render() {
	httpURL = window.httpURL;  
    return (
		<div style={{height:'100%'}}>
			<Header />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div> 
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-10 col-centered">
						<div className="col-sm-6 col-xs-11 padding-remove">
							<table className="tableLayout1" style={{width:this.state.width}}>
								<thead>
									<tr>
										<th style={{width:50, display:'none'}}>Machine Type Id</th>
										<th style={{width:100}}>
											<input onChange={this.setMachineTable} type="text" className="form-control inp-search" id="machineType" placeholder="Machine Type" />
										</th>
										<th style={{width:100}}>
											<input onChange={this.setMachineTable} type="text" className="form-control inp-search" id="perDayCapacity" placeholder="Per Day Capacity" />
										</th>
									</tr>
								</thead>
							</table>
							<div className="machineTableDivs col-sm-12 col-xs-11 padding-remove">
								<table id="machineTable" className="tableLayout">
									<colgroup>
										<col width="100" />
										<col width="100" />
									</colgroup>
									<tbody id="machineTableBody">
									</tbody>
								</table>
							</div>
						</div>
						<div className="col-sm-1 col-xs-1">
							<span id="addMachine" title="Add Machine Type" onClick={this.addMachineReady} className="addIcon glyphicon glyphicon-plus-sign"></span>
						</div>
						<div className="col-sm-5 col-xs-12">
							<form id="machineAddForm" className="form-horizontal">
								<div className="form-group">
									<label className="control-label col-sm-5">Machine Type:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Machine Type" id="inp_machineType"/>
									</div>
								</div>
								<div className="form-group">
									<label className="control-label col-sm-5">Per Day Capacity:<span style={{color:"red"}}>*</span></label>
									<div className="col-sm-7">
										<input type="text" className="form-control" placeholder="Per Day Capacity" id="inp_perDayCapacity"/>
									</div>
								</div>
								<div className="form-group" style={{marginTop:50}}>
									<div className="col-sm-12 text-center">
										<button type="button" onClick={this.maintainMachine} className="btn btn-warning">Save</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default MaintainMachine;
